import { SelectOption } from "../common/components/form/Select";

export enum HousingRule {
    PARAGRAPH_5A = "5a",
    PARAGRAPH_5B = "5b",
    PARAGRAPH_5C = "5c",
    PARAGRAPH_5D = "5d",
    PARAGRAPH_5E = "5e",
    PARAGRAPH_5F = "5f",
    PARAGRAPH_5G = "5g",
    PARAGRAPH_5H = "5h",
    PARAGRAPH_5I = "5i",
    PARAGRAPH_5J = "5j",
    PARAGRAPH_5K = "5k",
    PARAGRAPH_5L = "5l",
    PARAGRAPH_5M = "5m",
    PARAGRAPH_5N = "5n",
    PARAGRAPH_5O = "5o",
}

export const HousingRuleOptions: SelectOption[] = [
    {
        value: HousingRule.PARAGRAPH_5A,
        label: "5(a)",
    },
    {
        value: HousingRule.PARAGRAPH_5B,
        label: "5(b)",
    },
    {
        value: HousingRule.PARAGRAPH_5C,
        label: "5(c)",
    },
    {
        value: HousingRule.PARAGRAPH_5D,
        label: "5(d)",
    },
    {
        value: HousingRule.PARAGRAPH_5E,
        label: "5(e)",
    },
    {
        value: HousingRule.PARAGRAPH_5F,
        label: "5(f)",
    },
    {
        value: HousingRule.PARAGRAPH_5G,
        label: "5(g)",
    },
    {
        value: HousingRule.PARAGRAPH_5H,
        label: "5(h)",
    },
    {
        value: HousingRule.PARAGRAPH_5I,
        label: "5(i)",
    },
    {
        value: HousingRule.PARAGRAPH_5J,
        label: "5(j)",
    },
    {
        value: HousingRule.PARAGRAPH_5K,
        label: "5(k)",
    },
    {
        value: HousingRule.PARAGRAPH_5L,
        label: "5(l)",
    },
    {
        value: HousingRule.PARAGRAPH_5M,
        label: "5(m)",
    },
    {
        value: HousingRule.PARAGRAPH_5N,
        label: "5(n)",
    },
    {
        value: HousingRule.PARAGRAPH_5O,
        label: "5(o)",
    },
];
